(() => {
  function resolve(variant, country) {
    if (!variant || variant.available === false) return {status: 'unavailable'};
    const route = variant.routes?.[country];
    if (!route) return {status: 'destinationUnavailable'};
    const local = route.local;
    if (local && route[local] && (local === 'us' ? variant.usLocal : variant.euLocal) === true) return {status: 'local', origin: local, days: route[local].days};
    if (variant.cnAvailable === true && route.cn) return {status: local && route[local] ? 'restocking' : 'available', origin: 'cn', days: route.cn.days};
    return {status: 'unavailable'};
  }
  globalThis.DnaskateDeliveryLogic = Object.freeze({resolve});
  if (customElements.get('dnaskate-delivery-estimate')) return;
  customElements.define('dnaskate-delivery-estimate', class extends HTMLElement {
    connectedCallback() {
      try {
        this.variants = JSON.parse(this.querySelector('[data-delivery-variants]').textContent);
        this.labels = JSON.parse(this.querySelector('[data-delivery-labels]').textContent);
      } catch { this.hidden = true; return; }
      this.section = this.closest('.shopify-section') || document;
      this.onChange = () => {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.updateFromForm(), 250);
      };
      this.section.addEventListener('change', this.onChange);
      this.section.addEventListener('variant:change', this.onChange);
      this.observer = new MutationObserver(records => {
        if (records.some(r => !this.contains(r.target))) this.onChange();
      });
      this.observer.observe(this.section, {childList: true, subtree: true, attributes: true, attributeFilter: ['value']});
      this.update(this.dataset.selectedVariant);
    }
    disconnectedCallback() {
      this.section?.removeEventListener('change', this.onChange);
      this.section?.removeEventListener('variant:change', this.onChange);
      this.observer?.disconnect();
      clearTimeout(this.timer);
    }
    updateFromForm() {
      const input = this.section.querySelector('form[action*="/cart/add"] [name="id"]');
      this.update(input?.value || this.dataset.selectedVariant);
    }
    dateRange(days) {
      const match = String(days || '').match(/^(\d+)-(\d+)$/);
      if (!match || Number(match[2]) < Number(match[1])) return null;
      const format = new Intl.DateTimeFormat(document.documentElement.lang || 'en', {month: 'short', day: 'numeric'});
      const start = new Date(), end = new Date();
      start.setDate(start.getDate() + Number(match[1]));
      end.setDate(end.getDate() + Number(match[2]));
      return `${format.format(start)}–${format.format(end)}`;
    }
    update(variantId) {
      const variant = this.variants.find(v => String(v.id) === String(variantId));
      const result = resolve(variant, this.dataset.country);
      this.querySelector('.dnaskate-delivery__status').textContent = this.labels[result.status] || '';
      this.querySelector('.dnaskate-delivery__origin').textContent = result.origin ? this.labels[result.origin] : '';
      const dates = result.origin ? this.dateRange(result.days) : null;
      this.querySelector('.dnaskate-delivery__date').textContent = result.origin ? dates ? `${this.labels.estimated} ${dates}` : this.labels.unknown : '';
      this.hidden = false;
    }
  });
})();
